// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"64":"editEvent","535":"login"}[chunkId] + "." + {"64":"350319c8d6e6f98bd33d","535":"76b5ee46da231dbcba70"}[chunkId] + ".bundle.js";
};